import { registerPlugin, CapacitorHttp, HttpResponse } from "@capacitor/core";
import { BackgroundGeolocationPlugin } from "@capacitor-community/background-geolocation";
const BackgroundGeolocation = registerPlugin<BackgroundGeolocationPlugin>("BackgroundGeolocation");
import EventTarget from "@ungap/event-target";
import { UrlProvider } from "../../Infrastructure/UrlProvider";

interface EventMap {
    "logger-started": DeviceDetails;
    "logger-stopped": DeviceDetails;
}

interface Location {
    latitude: number;
    longitude: number;
}


class Ringbuffer<TValue> {
    private _values: TValue[] = [];
    private _position = 0;
    private _numberOfValues = 0;

    constructor(private _size = 10) {


    }

    push(value: TValue) {
        this._values[this._position] = value;

        this._position++;

        if (this._numberOfValues < this._size)
            this._numberOfValues++;

        if (this._position === this._size) {
            this._position = 0;
        }
    }

    get values() {
        return this._values.slice(0, this._numberOfValues);
    }
}

export interface LogStatement {
    time: Date;
    message: string;
}

export class FleetLoggerStore {
    private _eventTarget = new EventTarget();
    private _enabled = false;
    private _lastLocation: Location;
    private _log: Ringbuffer<LogStatement> = new Ringbuffer<LogStatement>(30);
    private static _instance = new FleetLoggerStore();
    private _logCallback = (statements: LogStatement[]) => { };
    private _deviceDetails: DeviceDetails;
    private _callbackId: string;
    public get deviceDetails() { return this._deviceDetails; }
    public set deviceDetails(value: DeviceDetails) { this._deviceDetails = value; }
    static get instance() { return FleetLoggerStore._instance; }
    public get enabled() { return this._enabled; }
    public set enabled(value: boolean) { this._enabled = value; }

    public set logCallback(value: (statements: LogStatement[]) => void) { this._logCallback = value; }

    private constructor() {
        setTimeout(() => {
            this.log("Application started");
        }, 100);
    }

    public async settings() {
        await BackgroundGeolocation.openSettings();
    }

    addEventListener<K extends Extract<keyof EventMap, string>>(type: K, listener: (this: EventSource, ev: CustomEvent<EventMap[K]>) => any, options?: boolean | AddEventListenerOptions) {
        return this._eventTarget.addEventListener(type, listener, options);
    }

    removeEventListener<K extends Extract<keyof EventMap, string>>(type: K, listener: (this: EventSource, ev: CustomEvent<EventMap[K]>) => any, options?: boolean | AddEventListenerOptions) {
        return this._eventTarget.removeEventListener(type, listener, options);
    }

    private emit<K extends Extract<keyof EventMap, string>, T extends EventMap>(type: K, value: T[K]) {
        return this._eventTarget.dispatchEvent(new CustomEvent(type, { detail: value }));
    }

    public get lastLocation() {
        return this._lastLocation;
    }

    public async start() {

        try {
            this._callbackId = await BackgroundGeolocation.addWatcher({
                backgroundMessage: "Cancel to prevent battery drain.",
                backgroundTitle: "Tracking You.",
                requestPermissions: true,
                stale: true,
                distanceFilter: 0
            }, async (position, error) => {
                if (error) {
                    if (error.code === "NOT_AUTHORIZED") {
                        if (window.confirm(
                            "This app needs your location, " +
                            "but does not have permission.\n\n" +
                            "Open settings now?"
                        )) {
                            // It can be useful to direct the user to their device's
                            // settings when location permissions have been denied. The
                            // plugin provides the 'openSettings' method to do exactly
                            // this.
                            BackgroundGeolocation.openSettings();
                        }
                    }
                    return console.error(error);
                }

                await this.doSend({
                    deviceId: this.deviceDetails.deviceId,
                    name: this._deviceDetails.name,
                    phoneNumber: this._deviceDetails.phoneNumber,
                    initials: this._deviceDetails.initials,
                    latitude: position.latitude,
                    longitude: position.longitude
                });

                this._lastLocation = {
                    latitude: position.latitude,
                    longitude: position.longitude
                };
            });

            this.emit("logger-started", this.deviceDetails);


            this.log("Started.");
        } catch (error) {

            // todo: remove
            this.emit("logger-started", this.deviceDetails);

            this.log("Error: " + error);
        }



    }

    public async stop() {
        await BackgroundGeolocation.removeWatcher({
            id: this._callbackId
        });

        this.emit("logger-stopped", this.deviceDetails);
        this.log("Stopped.");
    }

    private doSend = async (requestBody: CollectRequest) => {
        const bodyData = JSON.stringify(requestBody);

        let response: HttpResponse;
        try {
            response = await CapacitorHttp.post({
                url: `${UrlProvider.root}/api/collector`,
                data: bodyData,
                headers: {
                    "Content-Type": "application/json"
                }
            });
        } catch (error) { 
            console.error(error);
            return;
        }

        if (response.status === 200)
            this.log(`OK. Sent ${requestBody.latitude}, ${requestBody.longitude}`);
        else
            this.log(`Error ${response.status} ${response.status}. Tryting to send ${bodyData}`);


    }

    private doSend2 = async (requestBody: CollectRequest) => {
        const bodyData = JSON.stringify(requestBody);

        const response = await fetch(`${UrlProvider.root}/api/collector`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: bodyData
        });

        if (response.ok)
            this.log(`OK. Sent ${requestBody.latitude}, ${requestBody.longitude}`);
        else
            this.log(`Error ${response.status} ${response.statusText}. Tryting to send ${bodyData}`);


    }

    private log = (message: string) => {
        // this._log.push({
        //     time: new Date(),
        //     message: message
        // });
        // this._logCallback(this._log.values);
    }
}

export interface DeviceDetails {
    deviceId: string;
    name: string,
    phoneNumber: string,
    initials: string;
}

export interface CollectRequest extends DeviceDetails {
    latitude: number,
    longitude: number,
    accuracy?: number,
    altitude?: number,
    altitudeAccuracy?: number,
    speed?: number,
    heading?: number
    timestamp?: number;
}


